export default __webpack_public_path__ + "static/mechenism_b-7c10d3b210fc0c6b9954bf110995e112.jpg";